import clsx from 'clsx';
import styles from './PlateEditor.module.scss';

/**
 * Class names for the editor's content wrapper (the element around
 * <PlateContent>). Kept as a pure function so the variant logic is unit-testable
 * without rendering the whole editor.
 *
 * - `fullHeight`: wrapper grows to fill its parent (the one-pager/EL canvas).
 * - `bounded`: wrapper gets a fixed max-height with an internal scrollbar — used
 *   by compact inputs like the comments box (RECUR-26761 AC1). The max-height
 *   VALUE is dynamic and applied inline by the caller; this class supplies the
 *   static overflow/flex behaviour.
 */
export function contentWrapClassNames({ fullHeight, bounded }: { fullHeight?: boolean; bounded?: boolean }): string {
    return clsx(styles.contentWrap, fullHeight && styles.contentScroll, bounded && styles.contentScrollBounded);
}
